import Vue from 'vue'

export default {
    UPDATE_FAQS (state, value) {
        Vue.set(state, 'faqs', value);
    },
  SET_FAQS (state, value) {
        this.commit('UPDATE_FAQS', value);
    },
    SET_SELECTED_FAQ (state,  value ) {
      Vue.set(state, 'selectedFaq', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/faqs/mutations.js